import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"

interface Props {
  active: boolean
}

export const Trigger = styled.span`
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
  `}
  position: absolute;
`

export const ActiveCard = styled(Card)<Props>`
  position: relative;
  cursor: pointer;
  ${({active, theme}) => {
    if(active) {
      return `border: 2px solid ${theme.colors.success};`
    } else {
      return "border: 2px solid transparent;"
    }
  }}
`

export const WalletPointsCard = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.phoneLandscape`
      padding-right: ${theme.spacing.two};
    `}
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      padding-left: ${theme.spacing.two};
    `}
    margin-bottom: ${theme.spacing.one};
  `}
`

export const CashCard = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      padding-left: ${theme.spacing.two};
    `}
    margin-bottom: ${theme.spacing.one};
  `}
`
